var Image                 = require("app/ui/Image"),
    ImageOptimizerSupport = require("app/ui/ImageOptimizerSupport"),
    findBestFittingSlide  = require("app/utils/findBestFittingSlide"),
    frameThrottle         = require("enyo-perf/utils").frameThrottle,
    get                   = require("object-path").get,
    kind                  = require("enyo/kind");

require("app/ui/ImageSlide.less");

module.exports = kind(/** @lends  app.ui.ImageSlide.prototype */ {

    /**
     * @private
     */
    name: "app.ui.ImageSlide",

    /**
     * @private
     */
    classes: "app-ui-image-slide",

    /**
     * The dataset
     *
     * @type  {?Object}
     * @public
     */
    data: null,

    /**
     * @private
     */
    components: [{
        name:                    "image",
        kind:                    Image,
        mixins:                  [ImageOptimizerSupport],
        classes:                 "app-ui-image-slide__image",
        imageResolutionStepSize: 480,
        attributes:              {
            loading:  "eager",
            decoding: "async"
        }
    }],

    /**
     * @private
     */
    bindings: [{
        from: ".slider.aspectRatio",
        to:   ".aspectRatio"
    }],

    /**
     * @private
     */
    observers: {
        update: ["data", "aspectRatio"]
    },

    /**
     * @method
     * @private
     */
    create: kind.inherit(function(sup) {
        return function() {
            this.update = frameThrottle(this.bindSafely(this.update));
            sup.apply(this, arguments);
            this.update();
        };
    }),

    /**
     * Determine which image source to use
     *
     * @private
     */
    update: function() {
        var data        = this.data || {},
            $image      = this.$.image,
            aspectRatio = this.get("aspectRatio") || 1,
            image       = findBestFittingSlide(data, aspectRatio);

        $image.set("rawImageSrc", image ? {
            width:  image.width || null,
            height: image.height || null,
            ratio:  image.aspect_ratio || null,
            src:    get(image, "url", null)
        } : null);
    }

});
